"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var flatpickr_1 = __importDefault(require("flatpickr"));
flatpickr_1.default.l10ns.default.rangeSeparator = ' thru ';
flatpickr_1.default.l10ns.default.weekdays.shorthand = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
